import { Route, withRouter } from 'react-router-dom';

import ClassVideo from './components/ClassVideo';
import Dashboard from './components/Dashboard';

const LiveClass = () => {
  return (
    <>
      <Route exact path="/live/:id" component={ClassVideo} />
      <Route exact path="/live" component={Dashboard} />
    </>
  );
};

export default withRouter(LiveClass);
